function important(value) {
  return value + ' !important'
}

export { important }
export default important
